import messageIdMapping from "../IdMappings/MessageIdMapping.ts";

export class MessageNode {
    id: string | null;
    childNum: number | null;
    message: any | null;
    children: string[];
    parent: string | null;
    metadata: any;

    constructor(id: string | null = null, childNum: number | null = null, message: any = null, children: string[] = [], parent: string | null = null, metadata: any = {}) {
        this.id = id;
        this.childNum = childNum;
        this.message = message;
        this.children = children;
        this.parent = parent;
        this.metadata = metadata;

        if (id && !(id in messageIdMapping)) {
            // Hacky, but there's a weird edge case where if a tool is called and the tool message is generated instantly (e.g. hardcode tool message),
            // the tool's message content gets changed to an empty array, even though message and this.message are passed through properly
            if (message && message.role === "tool") {
                messageIdMapping[id] = {...this, message};
            } else {
                messageIdMapping[id] = this;
            }
        }
    }

    deepCopy(): MessageNode {
        return new MessageNode(
            this.id,
            this.childNum,
            this.message ? {...this.message} : null,
            [...this.children],
            this.parent,
            this.metadata ? {...this.metadata} : null,
        );
    }
}
